import { gql } from '@apollo/client';

export interface IHostRequest {
  id: number;
}
export interface IHostResponse {
  hostOverview: {
    position: number;
    group_id: number;
  };
}
export const HOST = gql`
  query draggableHostData($id: Int!) {
    hostOverview(id: $id) {
      position
      group_id
    }
  }
`;

export interface IHostGroupRequest {
  id: number;
}
export interface IHostGroupResponse {
  hostGroupOverview: {
    title: string;
    priority: number;
    customization?: {
      color: string;
    };
  };
}
export const HOST_GROUP = gql`
  query draggableHostGroupData($id: Int!) {
    hostGroupOverview(id: $id) {
      title
      priority
      customization {
        color
      }
    }
  }
`;
